// Résolution dynamique de l'URL API — évite les problèmes CORS avec les domaines personnalisés Emergent
const _envUrl = process.env.REACT_APP_BACKEND_URL || '';
let _resolved = _envUrl;
try {
  if (_envUrl && typeof window !== 'undefined') {
    const envOrigin = new URL(_envUrl).origin;
    if (envOrigin !== window.location.origin) {
      _resolved = ''; // URL interne Emergent → utiliser URLs relatives
    }
  }
} catch (e) {
  _resolved = '';
}

export const API_URL = _resolved;
export default _resolved;
